import { AddExpenseFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddExpenseFormModalContext = () => {
  const context = useContext(AddExpenseFormModalContext)

  if (!context) throw new Error('useAddExpenseFormModalContext has to be wrapped AddExpenseFormModalContextProvider')
  
  return context
}